import CatalogEditor from './CatalogEditor';

export default function CreateRoom() { return <CatalogEditor kind="room" />; }
